var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeveloperPortal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_23830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.353 104.256L138.01 136.877C129.34 130.265 112.001 128.061 106.711 141.726C101.421 155.392 118.76 165.825 127.43 165.531L115.527 197.712L19.4259 163.327C21.9239 157.89 28.2425 143.225 33.5325 128.061C29.1241 130.265 26.4792 130.706 19.4259 128.061C12.3726 125.416 8.4051 114.836 10.6093 107.341C12.8134 99.8472 19.8668 94.5572 30.0059 95.4389C38.1172 96.1442 41.6145 101.611 42.3492 104.256L55.1334 69.8706L150.353 104.256Z",
    fill: "#EBEBEB",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.116 107.782L139.773 140.404C131.103 133.792 113.764 131.587 108.474 145.253C103.184 158.919 120.523 169.352 129.193 169.058L117.291 201.239L21.1891 166.854C23.6871 161.417 30.0056 146.752 35.2956 131.587C30.8873 133.792 28.2424 134.232 21.1891 131.587C14.1358 128.942 10.1683 118.362 12.3725 110.868C14.5766 103.374 21.6299 98.0841 31.7691 98.9658C39.8804 99.6711 43.3777 105.137 44.1124 107.782L56.8965 73.3975L152.116 107.782Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5108 179.935L127.113 98.5925L143.774 128.974M21.2695 167.685L92.322 86.342L119.273 135.344M120.253 193.656L55.5707 73.1116",
    stroke: "#D8D8D8",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 6.98774,
    y2: -0.3,
    transform: "matrix(-0.571634 -0.957213 -0.733594 0.432532 51.7871 63.5181)",
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 4.66791,
    y2: -0.3,
    transform: "matrix(-0.249631 0.989636 -0.876896 -0.162872 58.6162 58.6594)",
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 4.84849,
    y2: -0.3,
    transform: "matrix(0.874032 0.292824 -0.258194 0.984477 44.5215 65.6742)",
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.853 189.735L46.7515 104.962",
    stroke: "#D8D8D8",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1021 177.485L34.9914 134.853M33.3814 132.694L17.8408 103.002",
    stroke: "#D8D8D8",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 7.22417,
    y2: -0.3,
    transform: "matrix(0.712861 0.811149 0.689509 -0.586469 275.81 236.284)",
    stroke: "#F8EDFF",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 4.54428,
    y2: -0.3,
    transform: "matrix(-0.0674053 -1.04451 0.938195 0.0170496 270.301 242.302)",
    stroke: "#F8EDFF",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 4.65728,
    y2: -0.3,
    transform: "matrix(-0.947885 -0.134184 0.0386672 -1.02715 282.562 232.844)",
    stroke: "#F8EDFF",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.488 128.494L268.973 225.477L171.108 207.843C171.108 205.199 172.078 194.53 175.957 173.018C171.108 173.899 166.7 173.899 163.614 173.018C160.528 172.136 150.389 164.466 152.152 154.944C154.356 143.041 164.495 139.955 171.108 140.396C176.398 140.749 180.365 143.776 181.688 145.245L187.86 111.301L222.245 117.032C221.657 115.122 220.834 110.067 222.245 105.129C224.008 98.9578 231.943 92.3453 242.964 94.5495C253.985 96.7537 257.511 105.57 256.63 111.301C255.924 115.886 252.809 120.559 251.34 122.322L287.488 128.494Z",
    fill: "#F8EDFF",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.251 132.02L270.736 229.003L172.871 211.37C172.871 208.725 173.841 198.057 177.72 176.544C172.871 177.426 168.463 177.426 165.377 176.544C162.291 175.663 152.152 167.992 153.915 158.47C156.12 146.568 166.259 143.482 172.871 143.923C178.161 144.275 182.129 147.302 183.451 148.772L189.623 114.828L224.008 120.558C223.42 118.648 222.597 113.593 224.008 108.656C225.771 102.484 233.706 95.8718 244.727 98.076C255.748 100.28 259.274 109.097 258.393 114.828C257.687 119.412 254.572 124.085 253.103 125.848L289.251 132.02Z",
    fill: "#F8EDFF",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.039 166.214C267.259 165.234 245.012 167.292 240.308 183.364C235.604 199.437 242.268 217.012 246.188 224.036",
    stroke: "#929292",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.668 128.973C256.478 143.837 216.786 184.835 202.576 168.175C192.311 156.14 172.195 163.764 162.394 175.525",
    stroke: "#929292",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.479 126.523C256.316 126.686 230.508 139.754 210.907 138.773C191.307 137.793 201.924 123.42 195.227 115.743",
    stroke: "#929292",
    strokeWidth: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_23830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloperPortal);
export default __webpack_public_path__ + "static/media/developer-portal.a150a294cf97d44b24c5218766be94db.svg";
export { ForwardRef as ReactComponent };